<template>
    <div>
        <v-container class="grey lighten-5" fluid>
            <v-row v-if="details">
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Cenniki najmu: {{ details.type.name }} - {{ details.company.name }}</v-card-title>
                        <v-card-text>
                          <v-btn class="mb-2" color="primary" @click="addRange()">Dodaj przedział dat</v-btn>
                            <v-tabs v-model="tab">
                              <v-tab v-for="(price, key) in details.prices" :key="price">
                                {{ tabLabel(price) }}
                                <v-btn class="red ml-2" @click.stop="removeRange(key)" size="small">
                                  <v-icon dark>
                                    mdi-delete
                                  </v-icon>
                                </v-btn>
                              </v-tab>
                              <v-tabs-items v-model="tab">
                                <v-tab-item v-for="(price, key) in details.prices" :key="price">
                                  <v-row>
                                    <v-col xl="6">
                                      <v-menu
                                          ref="dateFromMenu"
                                          v-model="dateFromMenus[key]"
                                          :close-on-content-click="true"
                                          transition="scale-transition"
                                          offset-y
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                              v-model="price.dateFrom"
                                              label="Data od"
                                              prepend-icon="mdi-calendar-blank"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="price.dateFrom"
                                            @input="dateFromMenus[key] = false"
                                            show-adjacent-months
                                            show-current
                                            :first-day-of-week="1"
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                    <v-col xl="6">
                                      <v-menu
                                          ref="dateToMenu"
                                          v-model="dateToMenus[key]"
                                          :close-on-content-click="true"
                                          transition="scale-transition"
                                          offset-y
                                      >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="price.dateTo"
                                                label="Data do"
                                                prepend-icon="mdi-calendar-blank"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker
                                              v-model="price.dateTo"
                                              @input="dateToMenus[key] = false"
                                              show-adjacent-months
                                              show-current
                                              :first-day-of-week="1"
                                          ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col class="mt-3">
                                      <strong>Ceny</strong>
                                      <div
                                          v-for="dayPrice in price.dayPrices"
                                          :key="dayPrice"
                                      >
                                        <v-row>
                                          <v-col>
                                            <v-text-field v-model="dayPrice.dayFrom"
                                                     type="number" label="Dni od"/>
                                          </v-col>
                                          <v-col>

                                            <v-text-field v-model="dayPrice.dayTo"
                                                     type="number" label="Dni do"/>
                                          </v-col>
                                          <v-col>

                                            <v-text-field v-model="dayPrice.price"
                                                     type="number" label="Cena"/>
                                          </v-col>
                                        </v-row>
                                      </div>
                                      <v-btn
                                          @click="addPrice(key)"
                                          color="secondary"
                                          class="mb-2 d-block"
                                          size="sm"
                                      >Dodaj nowy zakres</v-btn
                                      >
                                    </v-col>
                                  </v-row>
                                </v-tab-item>
                              </v-tabs-items>
                            </v-tabs>
                            <v-form>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="details.discount"
                                            class="pt-0"
                                            label="Zniżka %"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="details.insurance"
                                            class="pt-0"
                                            label="Ubezpieczenie (za dzień) netto"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="details.deposit"
                                            class="pt-0"
                                            label="Kaucja bez ubezpieczenia"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="details.depositWithInsurance"
                                            class="pt-0"
                                            label="Kaucja z ubezpieczeniem"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="details.ownContribution"
                                            class="pt-0"
                                            label="Wkład własny bez ubezpieczenia"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="details.ownContributionWithInsurance"
                                            class="pt-0"
                                            label="Wkład własny z ubezpieczeniem"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                @click="save"
                            >
                                Zapisz
                                <v-icon size="24" right>
                                    mdi-content-save-outline
                                </v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <modal-loader :show="loading"/>
    </div>
</template>

<script>
import api from '../services/api';
import humanFileSize from '../mixins/humanFileSize';
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";
import moment from "moment";

export default {
    components: {
        ModalLoader,
    },
    mixins: [
        formatters,
        humanFileSize,
        permissions,
    ],
    savedCategoryDetails: null,
    props: ['id'],
    data() {
        return {
            tab: null,
            loading: false,
            loadingDetails: false,
            loadingServices: false,
            loadingFields: false,
            details: null,
          dateToMenus: [],
          dateFromMenus: [],
        }
    },
    methods: {
      addRange() {
        this.details.prices.push({
          dateFrom: null,
          dateTo: null,
          dayPrices: [],
        })
        this.dateFromMenus.push(false)
        this.dateToMenus.push(false)
        this.activeItem = this.details.prices.length - 1
      },
      addPrice(rangeIndex) {
        this.details.prices[rangeIndex].dayPrices.push({
          dayFrom: null,
          dayTo: null,
          price: null,
        })
      },
      removeRange(index) {
        this.details.prices.splice(index, 1)
        this.tab = 0
      },
      tabLabel(price) {
        if (price.dateFrom && price.dateTo) {
          const from = moment(price.dateFrom).format('DD-MM')
          const to = moment(price.dateTo).format('DD-MM')
          if (from === '01-01' && to === '31-12') {
            return 'cały rok'
          }
          return `${from} - ${to}`
        } else {
          return 'nowy'
        }
      },
      async save() {
        const data = {
          ...this.details,
          type: null,
          discount: this.details.discount ? Number.parseInt(this.details.discount) : null,
        }
        await api.put(`/api/price-lists/${this.id}`, data);
        this.$root.$emit('notifySuccess', {
          html: 'Cennik najmu został zapisany.',
        });
        this.$router.push({name: 'price-lists'})
      },
        async loadDetails() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;

            let response;

            try {
                response = await api.get(`/api/price-lists/${this.id}`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać danych kategorii.',
                    error,
                });

                return;
            }

            this.loadingDetails = false;

            this.details = response.data;

            this.details.prices.forEach(() => {
              this.dateFromMenus.push(false)
              this.dateToMenus.push(false)
            })
        },
    },
    async created() {
        try {
            await this.loadDetails();
        } catch (e) {
            void (0);
        }
    },
    beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.id = to.params.id; // Store new user id in the local variable.

        this.loadDetails();
    },
}
</script>

<style scoped>
</style>
